import { ConfirmationDialogRaw } from "@/controls/modals/ConfirmationDialogRaw";
import { ErrorModal, HelmetDexteel, MesfModal } from "@dexteel/mesf-core";
import { capitalize } from "lodash-es";
import { useRef, useState } from "react";
import {
	TEMPLATE_MODAL_TITLES,
	TemplateModalTarget,
} from "../utils/templateModal";
import { TemplateDraftForm } from "./TemplateDraftForm";

type Props = {
	target: TemplateModalTarget | null;
	onHide: () => void;
};

export const UpsertDeleteTemplateModal = ({ target, onHide }: Props) => {
	const [error, setError] = useState("");
	const [isDirty, setIsDirty] = useState(false);
	const [isConfirmingClose, setIsConfirmingClose] = useState(false);

	const lastTarget = useRef<TemplateModalTarget | null>(null);
	if (target !== null) lastTarget.current = target;

	const shown = target ?? lastTarget.current;
	const title = shown === null ? "" : TEMPLATE_MODAL_TITLES[shown.mode];

	const requestClose = () => (isDirty ? setIsConfirmingClose(true) : onHide());

	return (
		<>
			{target !== null && (
				<HelmetDexteel title={`${capitalize(title)} - Inspection Templates`} />
			)}
			<MesfModal
				id="modal-inspection-template"
				title={title}
				open={target !== null}
				handleClose={requestClose}
				maxWidth="md"
			>
				{shown !== null && (
					<TemplateDraftForm
						key={shown.openedAt}
						target={shown}
						onHide={requestClose}
						onDirtyChange={setIsDirty}
						onSaved={onHide}
						onError={setError}
					/>
				)}
			</MesfModal>
			<ConfirmationDialogRaw
				open={isConfirmingClose}
				title="Discard Changes"
				message="The changes to this draft have not been saved. Close it anyway?"
				buttons={{ no: "Keep Editing", yes: "Discard" }}
				onClose={(value?: string) => {
					setIsConfirmingClose(false);
					if (value === "OK") onHide();
				}}
			/>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
